let observer = null;
let exitTimer = 0;
let listenersBound = false;
let state = null;

const mobileMediaQuery = window.matchMedia('(max-width: 899px)');

function isLayoutVisible(layout) {
  if (!(layout instanceof Element)) {
    return false;
  }

  return layout.getClientRects().length > 0 && getComputedStyle(layout).display !== 'none';
}

function getElements() {
  const layout = document.querySelector('.layout-mobile');

  if (!isLayoutVisible(layout)) {
    return null;
  }

  const source = layout.querySelector('.video__tickets-button:not(.video__tickets-button--sticky)');
  const sticky = layout.querySelector('.video__tickets-button--sticky');

  if (!(source instanceof Element) || !(sticky instanceof HTMLElement)) {
    return null;
  }

  return { source, sticky };
}

function clearExitTimer() {
  if (!exitTimer) {
    return;
  }

  window.clearTimeout(exitTimer);
  exitTimer = 0;
}

function hideStickyButton() {
  if (!state) {
    return;
  }

  clearExitTimer();
  state.sticky.classList.remove('video__tickets-button--visible');
  exitTimer = window.setTimeout(() => {
    if (state) {
      state.sticky.hidden = true;
    }

    exitTimer = 0;
  }, 240);
}

function showStickyButton() {
  if (!state) {
    return;
  }

  clearExitTimer();
  state.sticky.hidden = false;
  window.requestAnimationFrame(() => {
    state?.sticky.classList.add('video__tickets-button--visible');
  });
}

function disconnectObserver() {
  observer?.disconnect();
  observer = null;
}

function resetState() {
  disconnectObserver();
  clearExitTimer();

  if (state) {
    state.sticky.classList.remove('video__tickets-button--visible');
    state.sticky.hidden = true;
  }

  state = null;
}

function observeSource() {
  if (!state || observer) {
    return;
  }

  observer = new IntersectionObserver(([entry]) => {
    if (!entry || entry.target !== state?.source) {
      return;
    }

    if (entry.isIntersecting) {
      hideStickyButton();
      return;
    }

    showStickyButton();
  });
  observer.observe(state.source);
}

function syncNow() {
  if (!mobileMediaQuery.matches) {
    resetState();
    return;
  }

  const elements = getElements();

  if (!elements) {
    resetState();
    return;
  }

  if (state?.source !== elements.source || state.sticky !== elements.sticky) {
    resetState();
    state = elements;
    state.sticky.hidden = true;
  }

  observeSource();
}

export function initMobileTicketButton() {
  if (!listenersBound) {
    window.addEventListener('orientationchange', syncNow);
    listenersBound = true;
  }

  syncNow();
}

export function syncMobileTicketButton() {
  syncNow();
}
